import { compose } from 'redux';
import { withStyles } from '@material-ui/core';
import ClientListItemMessage from './ClientListItemMessage';
import styles from './ClientListItemMessage.styles';

export default compose(withStyles(styles))(ClientListItemMessage);
